import React from 'react'
import Breadcrumb from '../../../../Components/Breadcrumb/Breadcrumb'
import TestimonialsActivity from './TestimonialsActivity';
import StoriesActivity from './StoriesActivity';
import CreativePostActivity from './CreativePostActivity'

function OtherActivity() {
    return (
        <>
            <Breadcrumb data="FTL Activities" />
            <div className='content-body'>
                <TestimonialsActivity/>
                <StoriesActivity/>
                <CreativePostActivity/>
            </div>
        </>
    )
}

export default OtherActivity
